import React                            from 'react';
import {ListItemData} from '../../ListItem';
import {Bubble} from '../../components/Bubble/Bubble';


import  "./Text.scss";



export interface TextProps {
  item:ListItemData;
  isLeft:boolean;
}

export class Text extends React.Component<TextProps> {
  constructor(props:TextProps) {
    super(props);
  }

  render() {
    const item:any = this.props.item;
    const content =  (this.props.item.isHTML) ? <span className="swivl-linkContainer" dangerouslySetInnerHTML={{__html: item.message?.payload?.text }} />  : item.message?.payload?.text;
    return <Bubble isLeft={this.props.isLeft} loadLate={true}>{content}</Bubble>;
  }
}
